import React, { Component } from 'react'

class Footer extends Component {
    render() {
        return  <footer class="main-footer">
                    <div class="float-right d-none d-sm-inline">
                    DMR Consultoria e Sistemas Ltda
                    </div>
                    <strong>Copyright &copy; 2014-2019 <a href="https://wavii.com.br">Wavii</a>.</strong> Todos os direitos reservado.
                </footer>             
    }
}

export default Footer;
